import { Component, Prop, State, Watch, h, Event, EventEmitter } from '@stencil/core';
/* import { consumoApi } from '../../services/consumoApi'; */
import Ajv from 'ajv';
@Component({
  tag: 'dynamic-form',
  styleUrl: 'dynamic-form.css',
  shadow: false,
})

export class DynamicForm {
  @Prop() schema: any;
  /*  @Prop() schemaUrl: string; */
  @Prop() submitUrl: string;
  @Prop() endpointGet: string;
  @Prop() endpointPost: string;

  /*  @State() fields: any[] = []; */
  @State() fields: any = null;
  @State() formData: JSON;
  @State() errorMessage: string = '';
  @State() successMessage: string = '';
  @State() tabValidationStatus: Record<string, boolean> = {};

  @Event() submitForm: EventEmitter<any>;

  @Watch('schemaUrl')
  onSchemaChange(newValue: any) {
    this.fields = newValue;
  }

  private toastRef!: HTMLToastNotificationElement;
  /*  private modalRef!: HTMLModalConfirmElement; */


  /*   componentWillLoad() {
    console.log(this.fields);
    try {
      this.fields = JSON.parse(this.schema);
    } catch (e) {
      console.error('Error parsing schema:', e);
    }
  } */

  /**
   * Funcion que se ejecuta antes de que el componente se cargue
   * Se encarga de cargar el esquema del formulario, ya sea desde una URL o desde una propiedad
   * @author Pamela Mora Castañeda
   *
   * @async
   * @returns {*}
   */
  async componentWillLoad() {
    if (this.schema) {
      /* this.fields = this.schema; */

      this.fields = JSON.parse(this.schema);
      console.log('Schema loaded:', this.fields);

      if (this.fields !== null) {
        this.toastRef?.show?.('success');
      } else {
        this.toastRef?.show?.('danger');
      }
    } /* else if (this.schemaUrl) {
      try {
        const res = await fetch(this.schemaUrl);
        const res = await consumoApi(this.submitUrl, this.endpointGet, 'GET', null);

        const data = await res.json();
        console.log('Schema fetched:', data);
        this.fields = data;
      } catch (err) {
        console.error('Error fetching schema:', err);
      }
    } */
  }

  /**
   * Funcion para manejar el evento cuando el formulario no es válido
   * Se muestra un mensaje de error utilizando el componente toast-notification
   * @author Pamela Mora Castañeda
   *
   * @async
   * @param {CustomEvent} ev - Evento personalizado que contiene información sobre la validación del formulario
   * @returns {*}
   */
  private formNotValid = async (ev: CustomEvent) => {
    this.tabValidationStatus = { ...ev.detail };
    console.log('Form is not valid', ev.detail);
    await customElements.whenDefined('toast-notification');
    this.toastRef?.show?.('no-valid');
  };

  /**
   * Función para manejar el evento cuando el formulario es válido
   * Se muestra un mensaje de éxito utilizando el componente toast-notification
   * @author Pamela Mora Castañeda
   *
   * @async
   * @param {*} data - Datos del formulario que se han validado correctamente
   * @returns {*}
   */
  private formValidated = async data => {
    console.log('Form is valid', data);
    await customElements.whenDefined('toast-notification');
    // Validación de los tabs
    const uiSchema = this.fields[0]?.uiSchema;
    console.log('uiSchema', uiSchema);
    const validTabs: Record<string, boolean> = {};
    if (uiSchema?.elements?.length) {
      uiSchema.elements.forEach(el => {
        if (el.label) {
          validTabs[el.label] = true;
        }
      });
    }
    // Actualizar el estado de validación de los tabs
    this.tabValidationStatus = validTabs;

    // Validación del esquema JSON con AJV
    const jsonSchema = this.fields[0]?.jsonSchema;
    /*  const jsonSchema = this.fields[0]?.schema; */
    console.log('jsonSchemaaaaaaa', jsonSchema);
    if (jsonSchema && !this.validateWithAjv(data, jsonSchema)) {
      return;
    }


    // ✅ Emitimos los datos al proyecto externo
    this.submitForm.emit(data);
    /* this.toastRef?.show?.('in-progress'); */
    /*    this.saveData(data); */
  };

  /**
   * Funcion para manejar el evento de clic en el botón de guardar
   * Se espera a que el componente toast-notification esté definido antes de mostrar el mensaje
   * @author Pamela Mora Castañeda
   *
   * @async
   * @returns {*}
   */
  private handleSaveButtonClick = async () => {
    await customElements.whenDefined('toast-notification');
  };

  /*  private handleSendButtonModalClick = async () => {  
     await customElements.whenDefined('modal-confirm');
     this.modalRef?.show?.();
   }; */

  /**
   * Funcion para guardar los datos del formulario
   * Se envían los datos al servidor utilizando el servicio consumoApi
   * @author Pamela Mora Castañeda
   *
   * @async
   * @param {*} data - Datos del formulario que se van a guardar
   * @returns {*}
   */
  /*  private saveData = async data => {
     this.formData = data;
     try {
       const response = await consumoApi(this.fields[0].submitUrl, this.endpointPost, 'POST', this.formData);
       console.log('Data saved successfully:', response);
       this.toastRef?.show?.('success');
     } catch (error) {
       console.error('Error saving data:', error);
       this.toastRef?.show?.('danger');
     }
     this.submitForm.emit(this.formData);
   }; */

  private castTypesFromSchema(data: any, schema: any) {
    const result = { ...data };
    for (const key in schema.properties) {
      const prop = schema.properties[key];
      if (prop.type === 'number' && typeof result[key] === 'string') {
        const num = Number(result[key]);
        if (!isNaN(num)) result[key] = num;
      }
      if (prop.type === 'boolean' && typeof result[key] === 'string') {
        result[key] = result[key] === 'true' || result[key] === '1';
      }
    }
    return result;
  }

  private validateWithAjv(data: any, schema: any): boolean {
    const ajv = new Ajv({ allErrors: true, strict: false });
    console.log('Validating with AJV:', data, schema, ajv);
    const validate = ajv.compile(schema);

    // 🔹 Convertir valores antes de validar
    const castedData = this.castTypesFromSchema(data, schema);

    const valid = validate(castedData); console.log('AJV validate function:', valid);
    if (!valid) {
      console.error('Errores de validación AJV:', validate.errors);
      this.toastRef?.show?.('no-valid');
      return false;
    }

    return true;
  }

  /**
   * Funcion para renderizar un campo del formulario basado en su tipo
   * Utiliza componentes personalizados para cada tipo de campo
   * @author Pamela Mora Castañeda
   *
   * @param {*} field - Objeto que representa un campo del formulario
   * @returns {*}
   */
  renderField(field, tabName) {
    switch (field.type) {
      case 'string':
      case 'text':
      case 'email':
      case 'password':
        return (
          <input-text
            dataTab={tabName}
            type={field.type}
            label={field.title}
            name={field.name}
            required={field.required}
            value={field.value}
            placeholder={field.description}
            tooltip={field.title}
            maxLength={field.maxLength}
            minLength={field.minLength}
            pattern={field.pattern}
            disabled={field.disabled}
          ></input-text>
        );
      case 'number':
        return (
          <input-number
            dataTab={tabName}
            label={field.title}
            name={field.name}
            required={field.required}
            value={field.value}
            placeholder={field.title}
            tooltip={field.title}
          /* min={field.min}
          max={field.max} */
          ></input-number>
        );
      case 'select':
        return <select-box label={field.title} name={field.name} required={field.required} tooltip={field.tooltip} options={field.options} disabled={field.disabled}></select-box>;
      case 'radio':
      case 'checkbox':
      case 'boolean':
        return (
          <radio-check
            dataTab={tabName}
            label={field.title}
            name={field.name}
            required={field.required}
            tooltip={field.title}
            elements={field.options}
            type={field.type}
            disabled={field.disabled}
          ></radio-check>
        );
      case 'file':
        return (
          <input-file
            dataTab={tabName}
            label={field.title}
            name={field.name}
            required={field.required}
            value={field.value}
            tooltip={field.tooltip}
            multiple={field.multiple}
            accept={field.accept}
            size={field.size}
          ></input-file>
        );
      case 'switch':
        return (
          <input-switch
            dataTab={tabName}
            label={field.title}
            name={field.name}
            required={field.required}
            value={field.value}
            tooltip={field.tooltip}
            disabled={field.disabled}
            checked={field.checked}
          ></input-switch>
        );
      case 'textarea':
        return (
          <input-textarea
            dataTab={tabName}
            label={field.tile}
            name={field.name}
            required={field.required}
            value={field.value}
            tooltip={field.tooltip}
            placeholder={field.placeholder}
            disabled={field.disabled}
            maxLength={field.maxLength}
            minLength={field.minLength}
          ></input-textarea>
        );
      case 'datetime':
      case 'date':
        return (
          <datetime-picker
            dataTab={tabName}
            label={field.title}
            name={field.name}
            required={field.required}
            value={field.value}
            tooltip={field.tooltip}
            placeholder={field.placeholder}
            minDate={field.minDate}
            maxDate={field.maxDate}
          ></datetime-picker>
        );

      case 'object':
        return (
          <fieldset class="p-2">
            <div class="legend-title">
              <span class="legend-title-text fw-semibold fs-5">{field.title}</span>
            </div>
            {Object.entries(field.properties).map(([key, subField]) => {
              /*  const isRequired = field.required?.includes(key); */
              return typeof subField === 'object' && subField !== null ? (
                <div class="mb-3">{this.renderField({ ...subField, name: `${field.name}.${key}` /* , required: isRequired */ }, tabName)}</div>
              ) : null;
            })}
          </fieldset>
        );

      case 'array':
        return <array-field name={field.name} items={field.items}></array-field>;
      default:
        return 'Component not found';
    }
  }

  /**
   * Funcion para construir los campos del formulario a partir del esquema JSON
   * @author Pamela Mora Castañeda
   *
   * @private
   * @param {*} schema - Esquema JSON del formulario
   * @returns {*}
   */
  private buildFieldsFromSchema(schema) {
    const { jsonSchema, uiSchema } = schema;

    // Función para resolver el scope y obtener el campo correspondiente
    const resolveScope = (scope: string) => {
      const path = scope.replace('#/', '').split('/'); // ["properties", "direccion", "properties", "calle"]

      let schemaPointer = jsonSchema;
      let currentPath = ''; // Para recolectar el nombre del campo final
      for (let i = 0; i < path.length; i++) {
        const part = path[i];

        if (part === 'properties') continue;

        schemaPointer = schemaPointer.properties?.[part];
        if (!schemaPointer) break;

        currentPath += currentPath ? `.${part}` : part;
      }

      const isRequired = checkRequired(jsonSchema, currentPath);

      return {
        ...schemaPointer,
        name: currentPath,
        required: isRequired,
      };
    };

    // Función para verificar si un campo es requerido
    // Recorre el esquema JSON para encontrar si el campo es requerido
    const checkRequired = (schema, path) => {
      const keys = path.split('.');
      let pointer = schema;
      for (let i = 0; i < keys.length - 1; i++) {
        pointer = pointer.properties?.[keys[i]];
        if (!pointer) return false;
      }
      return pointer.required?.includes(keys[keys.length - 1]) || false;
    };

    const buildTabsFromUISchema = (uiElements) => {
      const tabButtons = [];
      const tabContents = [];
      const individualElement = [];

      uiElements.forEach((element, index) => {
        if (element.type === 'VerticalLayout' || element.type === 'HorizontalLayout') {
          const tabId = `v-pills-${element.label || 'tab' + index}`;

          const tabName = element.label || `tab${index + 1}`;
          const children = element.elements.map(el => {
            if (el.type === 'Control') {
              const field = resolveScope(el.scope);
              return (
                <div class={`mb-3 ${element.type === 'HorizontalLayout' ? 'col-sm-6' : ''}`} style={{ flex: 'auto' }}>
                  {this.renderField(field, tabName)}
                </div>
              );
            }
            return null;
          });

          const tabLabel = element.label || `Sección ${index + 1}`;
          const tabKey = tabLabel; // Usado también como data-tab en inputs

          const status = this.tabValidationStatus[tabKey];
          const icon = status === false
            ? <i class="bi bi-x text-danger ms-1 fs-5"></i>
            : status === true
              ? <i class="bi bi-check text-success ms-1 fs-5"></i>
              : null;

          tabButtons.push(
            <button
              class={`nav-link df-nav-link ${index === 0 ? 'active' : ''} px-4 py-3`}
              id={`${tabId}-tab`}
              data-bs-toggle="pill"
              data-bs-target={`#${tabId}`}
              type="button"
              role="tab"
              aria-controls={tabId}
              aria-selected={index === 0 ? 'true' : 'false'}
            >
              {tabLabel}
              {icon}
            </button>
          );

          tabContents.push(
            <div
              class={`tab-pane fade ${index === 0 ? 'show active' : ''}`}
              id={tabId}
              role="tabpanel"
              aria-labelledby={`${tabId}-tab`}
              tabIndex={0}
            >
              <div class={`${element.type === 'HorizontalLayout' ? 'row' : ''}`}>
                {children}
              </div>
            </div>
          );
        } else if (element.type === 'Control') {
          const field = resolveScope(element.scope);
          individualElement.push(
            <div class="mb-3">
              {this.renderField(field, element.label || `tab${index + 1}`)}
            </div>
          );
        }
      });

      return (
        <>
          {individualElement.length > 0 ? (
            <div class="d-flex align-items-start">
              <div class="nav flex-column nav-pills df-nav-pills me-tab fw-medium" id="v-pills-tab" role="tablist" aria-orientation="vertical" style={{ maxWidth: '15rem' }}>
                <button class="nav-link df-nav-link active" id="v-pills-home-tab" data-bs-toggle="pill" data-bs-target="#v-pills-home" type="button" role="tab" aria-controls="v-pills-home" aria-selected="true">Registro de información</button>
              </div>
              <div class="tab-content w-100 rounded-4 p-3 ms-tab" id="v-pills-tabContent">
                <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab" tabindex="0">
                  {individualElement}
                </div>
              </div>
            </div>
          ) : (
            <div class="d-flex align-items-start">
              <div class="nav flex-column nav-pills df-nav-pills me-tab fw-medium" id="v-pills-tab" role="tablist" aria-orientation="vertical" style={{ maxWidth: '15rem' }}>
                {tabButtons}
              </div>
              <div class="tab-content w-100 rounded-4 p-3 ms-tab" id="v-pills-tabContent">
                {tabContents}
              </div>
            </div>
          )}
        </>
      );
    };

    return buildTabsFromUISchema.call(this, uiSchema.elements);
  }

  render() {
    if (!this.fields) {
      return (
        <div class="container-loading">
          <loading-component />
        </div>
      );
    }

    return (
      <div class="py-4 px-3 my-4 bg-body border rounded card-form-tabs">
        {/* <form-validator idForm={this.fields[0].idForm} onFormValid={e => this.formValidated(e.detail)} onFormInvalid={e => this.formNotValid(e)}>
        {/* <h3 class="text-center mb-4">{this.fields[0].titleForm}</h3> 
        <h5 class="mb-4 subtitle-color">{this.fields[0].descriptionForm}</h5> */}

        <form-validator idForm={"fomr1"} onFormValid={e => this.formValidated(e.detail)} onFormInvalid={e => this.formNotValid(e)}>


          <div class="row">
            {/* -------------- WIZARD POR SECCIÓN NO RELACIONADA -------------- */}
            {this.buildFieldsFromSchema(this.fields[0])}

            {/* -------------- BOTONES GUARDAR - FINALIZAR -------------- */}
            <div class="d-flex justify-content-end mt-4">
              <save-button name="save-button" label="Guardar" onSaveButtonClick={this.handleSaveButtonClick}></save-button>
              {/* <send-button name="send-button" label="Finalizar" onSendButtonClick={this.handleSendButtonModalClick}></send-button> */}
            </div>
          </div>

          <toast-notification ref={el => (this.toastRef = el as HTMLToastNotificationElement & { show?: () => void })}></toast-notification>
          {/* <modal-confirm ref={el => (this.modalRef = el as HTMLModalConfirmElement & { show?: () => void })}></modal-confirm> */}
        </form-validator>
      </div>
    );
  }
}
